import { FC } from 'react';

interface TileSkeletonProps {
  wide?: boolean;
}

const TileSkeleton: FC<TileSkeletonProps> = ({ wide }) => (
  <div
    className={`
      rounded-[14px] p-5 overflow-hidden relative
      ${wide ? 'col-span-1 md:col-span-2' : ''}
    `}
    style={{
      background: 'var(--tile-bg)',
      border: '0.5px solid var(--tile-border)',
      minHeight: wide ? 120 : 170,
    }}
    data-testid="tile-skeleton"
  >
    {/* Shimmer overlay */}
    <div
      className="absolute inset-0 animate-shimmer"
      style={{
        background: 'linear-gradient(90deg, transparent 0%, var(--tile-glow) 50%, transparent 100%)',
        backgroundSize: '200% 100%',
      }}
    />
    {/* Placeholder bars */}
    <div className="space-y-3 relative">
      <div className="h-3 w-20 rounded" style={{ background: 'var(--tile-bar-bg)' }} />
      <div className="h-5 w-32 rounded" style={{ background: 'var(--tile-bar-bg)' }} />
      <div className="h-3 w-24 rounded" style={{ background: 'var(--tile-bar-bg)' }} />
    </div>
  </div>
);

export default TileSkeleton;
